// extracted by mini-css-extract-plugin
export default {"TaCPage":"TermsAndConditions_TaCPage__vdK1p","pageContainer":"TermsAndConditions_pageContainer__KWGNd","section":"TermsAndConditions_section__JoxBO"};